import { render, staticRenderFns } from "./dashboard_mobile.vue?vue&type=template&id=79977d51&scoped=true&"
import script from "./dashboard_mobile.vue?vue&type=script&lang=js&"
export * from "./dashboard_mobile.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_mobile.vue?vue&type=style&index=0&id=79977d51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79977d51",
  null
  
)

component.options.__file = "dashboard_mobile.vue"
export default component.exports